export default {
    'CODE_ERR_NETWORK': -1,
    'CODE_OK': 0,
    'CODE_ERR_SYSTEM': 1000,
    'CODE_ERR_APP': 1001,
    'CODE_ERR_PARAM': 1002,
    'CODE_ERR_DATA_REPEAT': 1003,
    'CODE_ERR_LOGIN_FAILED': 1004,
    'CODE_ERR_NO_LOGIN': 1005,
    'CODE_ERR_NO_PRIV': 1006,
    'CODE_ERR_TASK_ERROR': 1007,
    'CODE_ERR_USER_OR_PASS_WRONG': 1008,
    'CODE_ERR_NO_DATA': 1009,
}